class StoreData {
    // 存储数据
    data = {};
    registerCode = "";
    constructor(key, registerCode) {
        this.key = key;
        this.registerCode = registerCode;
        this.init();
    }
    // 获取数据
    init() {
        this.data = JSON.parse(localStorage.getItem(this.key)) || {};
    };
    get() {
        return this.data[this.registerCode];
    };
    // 保存数据
    add(value) {
        this.data[this.registerCode] = value;
        this.save();
    };
    // 删除数据
    remove() {
        delete this.data[this.registerCode];
        this.save();
    };
    save() {
        localStorage.setItem(this.key, JSON.stringify(this.data));
    }
    // 清空数据
    clear() {
        localStorage.removeItem(this.key);
    };

}
export default StoreData;